import has from 'lodash/has';
import mapKeys from 'lodash/mapKeys';
import {
  FILE_UPLOAD_PROBE_GET_SAMPLE_FAILURE,
  FILE_UPLOAD_PROBE_GET_SAMPLE_SUCCESS,
  FILE_UPLOAD_PROBE_REMOVE_STAGE,
  LOGOUT_COMPLETE,
} from 'js/constants/actionTypes';

const initialState = {};

export const fileUploadProbeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FILE_UPLOAD_PROBE_GET_SAMPLE_SUCCESS:
      return fileUploadProbeGetSampleSuccess(state, action);

    case FILE_UPLOAD_PROBE_GET_SAMPLE_FAILURE:
      return fileUploadProbeGetSampleFailure(state, action);

    case FILE_UPLOAD_PROBE_REMOVE_STAGE:
      return fileUploadProbeRemoveStage(state, action);

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};

export default fileUploadProbeReducer;

function fileUploadProbeGetSampleSuccess(state, action) {
  const {
    requestInfo: { id, stageIndex },
    result,
  } = action;
  const stateForThisResource = has(state, id) ? state[id] : {};

  return {
    ...state,
    [id]: {
      ...stateForThisResource,
      [stageIndex]: {
        response: result,
        error: null,
        sampleLastUpdatedAt: Date.now(),
      },
    },
  };
}

function fileUploadProbeGetSampleFailure(state, action) {
  const {
    requestInfo: { id, stageIndex },
  } = action;
  const stateForThisResource = has(state, id) ? state[id] : {};

  return {
    ...state,
    [id]: {
      ...stateForThisResource,
      [stageIndex]: {
        response: null,
        error: {
          code: action.code,
          error: action.error,
        },
        sampleLastUpdatedAt: Date.now(),
      },
    },
  };
}

function fileUploadProbeRemoveStage(state, action) {
  const { id, stageIndex } = action.payload;
  const stateForThisResource = has(state, id) ? { ...state[id] } : {};

  if (has(stateForThisResource, stageIndex)) {
    delete stateForThisResource[stageIndex];
  }

  const newState = mapKeys(stateForThisResource, (value, key) => {
    if (key === stageIndex) {
      return key;
    }

    const keyInt = parseInt(key, 10);
    const stageInt = parseInt(stageIndex, 10);
    if (Number.isNaN(keyInt) || Number.isNaN(stageInt)) {
      return key;
    }

    if (keyInt > stageInt) {
      return keyInt - 1;
    }

    return key;
  });

  return {
    ...state,
    [id]: newState,
  };
}
